import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import Mailchimp from "react-mailchimp-form";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sNewsletter } from "src/styles/sNewsletter.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  backgroundColor?: string;
};

const Newsletter = ({ style, className, backgroundColor }: Props) => {
  const { locale: lang } = useRouter();

  const inputPlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Emailová adresa";
      case `sk`:
        return "Emailová adresa";
      case `en`:
        return "Email address";
      default:
        return "Email address";
    }
  };

  const sendingPlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Odesílám...";
      case `sk`:
        return "Odosielam...";
      case `en`:
        return "Sending...";
      default:
        return "Sending...";
    }
  };
  const successPlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Děkujeme za přihlášení k odběru!";
      case `sk`:
        return "Ďakujeme, že ste sa prihlásili na odber!";
      case `en`:
        return "Thank you for subscribing!";
      default:
        return "Thank you for subscribing!";
    }
  };
  const errorPlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Došlo k neočekávané vnitřní chybě.";
      case `sk`:
        return "Vyskytla sa neočakávaná interná chyba.";
      case `en`:
        return "An unexpected internal error has occurred.";
      default:
        return "An unexpected internal error has occurred.";
    }
  };
  const emptyPlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Musíte vyplnit e-mail.";
      case `sk`:
        return "Musíte vyplniť e-mail.";
      case `en`:
        return "You must write an e-mail.";
      default:
        return "You must write an e-mail.";
    }
  };
  const duplicatePlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Příliš mnoho pokusů o přihlášení pro tuto e-mailovou adresu";
      case `sk`:
        return "Príliš veľa pokusov o odber pre túto e-mailovú adresu";
      case `en`:
        return "Too many subscribe attempts for this email address";
      default:
        return "Too many subscribe attempts for this email address";
    }
  };
  const buttonPlaceholder = () => {
    switch (lang) {
      case `cs`:
        return "Přihlásit!";
      case `sk`:
        return "Prihlásiť!";
      case `en`:
        return "Sign me up!";
      default:
        return "Sign me up!";
    }
  };

  return (
    <div
      className={composeClassNames([sNewsletter, className])}
      style={{ background: backgroundColor || constants.Theme.white }}
    >
      <Heading
        type={`h3`}
        title={<Translate tKey="Are you ready to improve you life?" />}
        className={composeClassNames([sGroupTitle, "newsletter-title"])}
      />
      <p className={"newsletter-subtitle"}>
        <Translate tKey="Sign up to get access to weekly tutorials, tips and join the community." />
      </p>
      <Mailchimp
        action={constants.Marketing.mailchimpSubscribeUrl}
        // action="https://jster.us7.list-manage.com/subscribe/post-json?u=ed40c0084a0c5ba31b3365d65&amp;id=ec6f32bf5e"
        fields={[
          {
            name: "EMAIL",
            placeholder: inputPlaceholder(),
            type: "email",
            required: true,
          },
        ]}
        messages={{
          sending: sendingPlaceholder(),
          success: successPlaceholder(),
          error: errorPlaceholder(),
          empty: emptyPlaceholder(),
          duplicate: duplicatePlaceholder(),
          button: buttonPlaceholder(),
        }}
      />
    </div>
  );
};

export default Newsletter;
